import { DrawerType } from "./drawers.models";

/** Drawer stack vs full-page CRUD card (`/edit/:id`, `/add/:idCopy`). */
export enum UserActionHistoryOrigin {
  Drawer = "drawer",
  RouteCard = "routeCard",
}

export interface IUserActionHistoryEntry {
  id: string;
  recordedAt: number;
  origin: UserActionHistoryOrigin;
  title: string;
  pathname: string;
  search: string;
  drawerType?: DrawerType;
  /** JSON-serializable subset of drawer props (no functions) for optional reopen. */
  drawerPayload?: Record<string, unknown>;
}

export interface IUserActionsHistoryStored {
  v: 1;
  items: IUserActionHistoryEntry[];
}
